const listCountryPrice = {
	US: '48',
	MX: '40',
	CA: '13',
	JP: '38',
	GB: '17',
	AU: '17',
	BR: '17',
	ZA: '17',
	CH: '17',
	NO: '17',
	SA: '10',
	AT: '17',
	MT: '17',
	PT: '17',
	SE: '17',
	CY: '17',
	SK: '17',
	GR: '17',
	BG: '17',
	NL: '17',
	BE: '17',
	PL: '17',
	IE: '17',
	DK: '17',
	EE: '17',
	FI: '17',
	HR: '17',
	LV: '17',
	LT: '17',
	RO: '17',
	LU: '17',
	DE: '17',
	IT: '17',
	FR: '17',
	ES: '17',
	SI: '17',
	HU: '17',
	CZ: '17',
}

export default listCountryPrice
